module.exports = __webpack_public_path__ + "img/BAANSAITARA.439e00a4.png";